import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";
import { NationalUniversityFilterDetails } from "../types/nationalUniversityTypes";

export const nationalUniversityFilterInitialValues: NationalUniversityFilterDetails = {
  name: "",
  settlementCode: "",
  address: "",
  zipCode: "",
  website: "",
  isActive: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "name",
};
